import {Connection, createConnection} from 'typeorm';
import {DatabaseContract} from 'common/tool/DatabaseContract';
import {FileSystem} from 'common/tool/FileSystem';
import {FileSystemContract} from 'common/tool/FileSystemContract';
import {BadParameterException} from 'common/exception/BadParameterException';
import {Logger} from 'common/tool/Logger';

// TypeORM documation, types: https://github.com/typeorm/typeorm/blob/master/src/driver/types/ColumnTypes.ts
export class Database implements DatabaseContract {
    private root: string;
    private db: any;
    private connection: Connection;

    public constructor(root: string) {
        this.root = root;
    }

    public async connect(name: string, entities: any[]): Promise<void> {
        if (this.db === undefined) {
            await this.init();
        }

        const con: any = this.db[name];
        if (con !== undefined) {
            con.entities = entities;
            con.logging = ['error'];
            con.logger = true;
            con.bigNumberStrings = false;
            if (con.timezone === undefined) {
                con.timezone = 'Z';
            }
            if (con.charset === undefined) {
                con.charset = 'UTF8_GENERAL_CI';
            }
            this.connection = await createConnection(con);
        } else {
            Logger.error(new BadParameterException('bad connection name'));
        }
    }

    public async synchronize(): Promise<void> {
        if (this.connection !== undefined) {
            await this.connection.synchronize();
        }
    }

    public async close(): Promise<void> {
        return this.connection.close();
    }

    private async init(): Promise<void> {
        if (this.root === undefined) {
            this.db = {};
        } else {
            const fileSystem: FileSystemContract = new FileSystem();
            this.db = await fileSystem.readJson(this.root + 'data/db.json');
        }
    }
}
